import { ChangeDetectionStrategy, Component } from '@angular/core';
import { SettingsService } from '../../../core/settings/settings.service';
import { publishLast, refCount } from 'rxjs/operators';
import { faLinkedinIn, faTiktok } from '@fortawesome/free-brands-svg-icons';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';

@Component({
  selector: 'app-loyalty-club-footer',
  templateUrl: './loyalty-club-footer.component.html',
  imports: [
    TranslateModule,
    CommonModule,
    FontAwesomeModule,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LoyaltyClubFooterComponent {
  protected currentYear = new Date().getFullYear();
  protected settings$ = this.settingsService.getSettingsOnce().pipe(publishLast(), refCount());
  protected readonly linkedinIcon = faLinkedinIn;
  protected readonly tiktokIcon = faTiktok;

  constructor(private settingsService: SettingsService) {
  }
}
